import View from '@/components/view'
import { useGetCogUrlFromDiagnosis } from '@/hooks/queries/use-get-cog-url-from-diagnosis'
import { Shimmer } from '@/pages/diagnosis-view/components/shimmer'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'

import { CreatePulverizationMapStepper } from './create-pulverization-map-stepper'
import { InfestationSummary } from './infestation-summary'
import { WeedMap } from './weed-map'
import { ControlFillLayers } from './weed-map/control-fill-layers'
import { InfestationLayers } from './weed-map/infestation-layers'
import { PulverizationLayers } from './weed-map/pulverization-layers'

export function Weed() {
  const {
    step,
    shouldShowBuffer,
    infestationData,
    pulverizationData,
    resetStep,
    toggleFillToLayer,
    isPulverization,
    culture,
    diagnosisId,
  } = useCreatePulverizationMap()

  const { data: cogUrl } = useGetCogUrlFromDiagnosis(culture, diagnosisId)

  return (
    <View
      padding='XL'
      overflow
      aside={
        isPulverization ? (
          <CreatePulverizationMapStepper activeStep={step} goBack={resetStep} />
        ) : (
          <InfestationSummary />
        )
      }
      section={
        <>
          {!infestationData ? (
            <Shimmer />
          ) : (
            <WeedMap
              perimeter={infestationData.perimeter}
              mapLabel={step ? 'Mapa de pulverização' : 'Mapa de infestação'}
              cogUrl={cogUrl}
            >
              {step === 6 && pulverizationData ? (
                <PulverizationLayers layers={pulverizationData.layers} />
              ) : (
                <>
                  {!isPulverization && (
                    <ControlFillLayers
                      layersMap={infestationData.layersMap}
                      handleLayerChange={toggleFillToLayer}
                    />
                  )}
                  <InfestationLayers
                    layersMap={infestationData.layersMap}
                    mergedLayersMap={infestationData.mergedLayersMap}
                    shouldShowBuffer={shouldShowBuffer}
                    isPulverization={isPulverization}
                  />
                </>
              )}
            </WeedMap>
          )}
        </>
      }
    />
  )
}
